<template>
    <!--  修学心得-->
    <div class="taoist">
        <!-- 三级菜单 -->
        <div class="treeNav flex-start-wrap">
            <div
                @click="changeNav(index)"
                class="navItem"
                v-for="(nav,index) in cateList"
                :key="index"
                :class="{'navItemActive':index==nowNav}"
            >{{nav.cate_name}}</div>
        </div>
        <!-- 展示列表 -->
        <div
            @click="linkToDetail(item)"
            class="content flex-between"
            v-for="(item,index) in contentList"
            :key="index"
        >
            <div class="titleName oneLine">{{item.news_title}}</div>
            <div class="time">{{item.data}}</div>
        </div>
        <!-- 分页 -->
        <div class="pageBar">
            <div class="block">
                <el-pagination
                    :pager-count="3"
                    @current-change="handleCurrentChange"
                    background
                    :page-size="page.per_page"
                    layout=" prev, pager, next"
                    :total="page.total"
                    :prev-text="$t('preText')"
                    :next-text="$t('nextText')"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getTimeBeforeDay } from "../../common/js/common";
import { StudyExperienceList } from "../../api/apis";
export default {
    name: "",
    components: {},
    props: {
        cateList: {
            type: Array,
            default: () => []
        },
        title:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            nowNav: 0,
            currentNavId: "", //菜单id
            page: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 1
            },
            treeNav: [
                // {
                //     //三级菜单
                //     id: 1,
                //     name: "修學心得"
                // },
                // {
                //     id: 1,
                //     name: "生命的升華與沉澱"
                // },
                // {
                //     id: 1,
                //     name: "雲開的心得"
                // },
                // {
                //     id: 1,
                //     name: "緣生可貴"
                // },
                // {
                //     id: 1,
                //     name: "自覺自在"
                // }
            ],
            contentList: [
                // {
                //     create_title: "關於力量的一點體會",
                //     data: "2019-09-19"
                // },
                // {
                //     create_title: "關於力量的一點體會",
                //     data: "2019-09-19"
                // },
                // {
                //     create_title: "關於力量的一點體會",
                //     data: "2019-09-19"
                // }
            ]
        };
    },
    watch: {
        cateList() {
            if(localStorage.getItem("nowNav_type")==1){
                this.nowNav = 0;
            }else {
                this.nowNav = localStorage.getItem("nowNav") ? localStorage.getItem("nowNav") : 0;
            }
            this.currentNavId = this.cateList[this.nowNav].id;
            this.getExperienceList({
                limit: this.page.per_page,
                page: this.page.current_page
            });
        }
    },
    methods: {
        changeNav(index) {
            //改变导航（需要）
            this.nowNav = index;
            localStorage.setItem("nowNav", index);
            this.currentNavId = this.cateList[index].id;
            this.getExperienceList({ limit: this.page.per_page, page: 1 });
        },
        handleCurrentChange(e) {
            this.page.current_page = e;
            this.getExperienceList({ limit: this.page.per_page, page: e });
        },
        linkToDetail(item) {
            localStorage.removeItem("nowNav_type");
            this.$router.push({
                path: "/articleDetail",
                query: { name: "experience", id: item.id,title:this.title}
            }); //跳转到心得详情
        },
        //获取展示数据
        getExperienceList(page) {
            StudyExperienceList(this.currentNavId, page).then(res => {
                this.page.total = res.total;
                this.page.current_page = res.current_page;
                this.page.last_page = res.last_page;
                this.contentList = res.data;
            });
        }
    },
    mounted() {
        if(localStorage.getItem("nowNav_type")==1){
            this.nowNav = 0;
        }else {
            this.nowNav = localStorage.getItem("nowNav");
        }
        this.currentNavId = this.cateList[this.nowNav].id;
        this.getExperienceList({
            limit: this.page.per_page,
            page: this.page.current_page
        });
    }
};
</script>

<style scoped>
.taoist {
    color: #333333;


}

.title {
    padding: 0.64rem;
}

.navItem {
    line-height: 1.1rem;
    color:#047bcdff;
    margin: 0.64rem;
    font-size: 0.85rem;
    font-weight: 600;

}

.navItemActive {
    border-bottom: 0.11rem solid #047bcdff;
    color: #333333;
}
.titleName{
    width:15rem;
}
.titleLeft {
    font-size: 0.85rem;
    line-height: 1.8rem;

}

.content {
    /* height: 2.4rem; */
    border-bottom: 1px dashed #dfdfdf;
    line-height: 1.8rem;
    margin-left: 0.64rem;
    margin-right: 0.64rem;
    font-size: 0.85rem;

}
.time {
    color: #999999;
    font-size: 0.6rem;
}
.pageBar {
    margin-top: 3.5rem;
    text-align: center;
}
</style>
